import * as Yup from 'yup';
import { ObjectSchema } from 'yup';

export const detailsPageSchema = (): ObjectSchema =>
  Yup.object().shape({
    firstName: Yup.string().required().min(2),
    lastName: Yup.string().required().min(2),
  });
